import { useCallback, useState } from "react";
import { api } from "@/services/api";
import type { AccommodationDayInfoResponse } from "@/types/api";
import { logError } from "@/utils/logError";

interface UseAccommodationDayInfoReturn {
  loading: boolean;
  data: AccommodationDayInfoResponse | null;
  fetchDayInfo: (params: {
    dateFrom: string;
    dateTo: string;
    accoId: number;
  }) => Promise<AccommodationDayInfoResponse>;
}

export function useAccommodationDayInfo(): UseAccommodationDayInfoReturn {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AccommodationDayInfoResponse | null>(null);

  const fetchDayInfo = useCallback(
    async (params: { dateFrom: string; dateTo: string; accoId: number }) => {
      setLoading(true);

      try {
        const response = await api.getAccommodationDayInfo(params);
        setData(response);
        setLoading(false);
        return response;
      } catch (err) {
        const error = err instanceof Error ? err : new Error(String(err));
        logError(error);
        setLoading(false);
        throw error;
      }
    },
    [],
  );

  return {
    loading,
    data,
    fetchDayInfo,
  };
}
